class ApiDashboard {
    constructor(Restangular, ApiBaseResponseService, $q) {
        return {
            getDashboardCampaigns(filter) {
                return Restangular
                    .one('dashboard')
                    .customPOST(filter)
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            getCampaignCount(filter) {
                return Restangular
                    .one('campaigns/count')
                    .get(filter)
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            }
        };
    }
}

ApiDashboard.inject = ['Restangular', 'ApiBaseResponseService'];

export default ApiDashboard;


/** WEBPACK FOOTER **
 ** ./src/app/services/apiDashboard.js
 **/